export const useusersStore = defineStore('users', () => {
  const readUsers = useDirectusUsers()

  const user = ref()
  const users = ref([])
  const getUsers = computed(function () {
    return users
  })
  async function getUsersData() {
    // Directus plafonne limit=-1 à 1000 → paginer pour tout récupérer (4000+ users).
    const data = await paginateAll((page, limit) =>
      readUsers.getUsers({
        params: {
          fields: [
            '*',
            'dentsu_distributors_accesses.distributor.owner.*',
            'dentsu_distributors_accesses.level',
            'dentsu_distributors_accesses.distributor.title'
          ],
          sort: ['last_name'],
          page,
          limit,
        },
      })
    )
    users.value = data
    return users
  }

  return { users, getUsers, getUsersData, user }
})